import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { CustomReportPageView } from "./ui/CustomReportPageView";
import { useApiPostReports } from "../../fnx/reports/postReports";
import { showErrorToast } from "../../fnx/showError";
import { useDispatch, useSelector } from "react-redux";
import {
  CardProps,
  MenuItem,
  typeAlert,
} from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useNavigate } from "react-router-dom";
import { ReportState, ToastState } from "./resources/customReportsDTO";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
import showToast from "../../services/toast";
import { quoteAll, quoteAllClearData } from "../../store/generateQuote/actions";
import {
  getCurrentMonth,
  getCurrentSemester,
  getPreviousMonth,
  getQuarterDates,
} from "../../services/getDates";
import { formattedDateWithTime } from "../../utils/date";
import useUpdateData from "./helpers/reporData";
import { reportsClearData } from "../../store/reports/actions";

export const CustomReportPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [state, setState] = useState<ReportState>({
    enable: true,
    page: 1,
    limit: 5000,
    reportCard: [],
    reportTrigger: false,
    bodyReport: { page: 0, pageSize: 10 },
    dateRange: "",
  });
  const [toast, setToast] = useState<ToastState>({
    show: false,
    message: "",
    type: typeAlert.success,
  });

  const { newDownData, dataSeries, dataCategories, updateData } =
    useUpdateData(t);

  //CALL APIS
  const { loadingReports, responseReports, errorReports } = useApiPostReports(
    state.reportTrigger,
    state.bodyReport,
  );

  const { responseAllQuote, errorAllQuote, loadingAllQuote } = useSelector(
    (state: any) => ({
      responseAllQuote: state.Quote.responseAllQuote,
      errorAllQuote: state.Quote.errorAllQuote,
      loadingAllQuote: state.Quote.loadingAllQuote,
    }),
  );

  //END CALL APIS

  useEffect(() => {
    setState((prev) => ({ ...prev, reportTrigger: true }));
    const { startDate, endDate } = getCurrentMonth();
    callQuoteAll(startDate, endDate);
    setState((prev) => ({ ...prev, dateRange: "currentMonth" }));
  }, []);

  useEffect(() => {
    if (errorReports) {
      showErrorToast(errorReports, setToast, t);
      setState((prev) => ({ ...prev, reportTrigger: false }));
      dispatch(reportsClearData());
    }
  }, [errorReports]);

  useEffect(() => {
    if (errorAllQuote) {
      showErrorToast(errorAllQuote, setToast, t);
      dispatch(quoteAllClearData());
    }
  }, [errorAllQuote]);

  useEffect(() => {
    if (responseReports) {
      const data = responseReports.map((item: CardProps) => ({
        id: item.id,
        title: item.name,
        subTitle: "Por Rango de fechas",
      }));
      setState((prev) => ({
        ...prev,
        reportCard: data,
      }));
      dispatch(reportsClearData());
    }
  }, [responseReports]);

  useEffect(() => {
    if (responseAllQuote) {
      updateData(responseAllQuote);
      dispatch(quoteAllClearData());
    }
  }, [responseAllQuote]);

  const onClickMonthReport = (item: MenuItem) => {
    let startDate, endDate;
    switch (item.code) {
      case "currentMonth":
        ({ startDate, endDate } = getCurrentMonth());
        callQuoteAll(startDate, endDate);
        setState((prev) => ({ ...prev, dateRange: "currentMonth" }));
        break;
      case "prevMonth":
        ({ startDate, endDate } = getPreviousMonth());
        callQuoteAll(startDate, endDate);
        setState((prev) => ({ ...prev, dateRange: "prevMonth" }));
        break;
      case "currentQuarter":
        ({ startDate, endDate } = getQuarterDates("current"));
        callQuoteAll(startDate, endDate);
        setState((prev) => ({ ...prev, dateRange: "currentQuarter" }));
        break;
      case "prevQuarter":
        ({ startDate, endDate } = getQuarterDates("previous"));
        callQuoteAll(startDate, endDate);
        setState((prev) => ({ ...prev, dateRange: "prevQuarter" }));
        break;
      case "currentSemester":
        ({ startDate, endDate } = getCurrentSemester());
        callQuoteAll(startDate, endDate);
        setState((prev) => ({ ...prev, dateRange: "currentSemester" }));
        break;
    }
  };

  const openReport = (action: MenuItem, item: CardProps) => {
    if (action.name === "Previsualizar") {
      navigate(`/reports-sumamaries/${item.id}/${state.dateRange}`);
    }
  };

  const filterCalendar = (dates: any) => {
    const startDate =
      formattedDateWithTime(dates?.dateRange?.startDate) === "undefined" ||
      formattedDateWithTime(dates?.dateRange?.startDate) === "null" ||
      formattedDateWithTime(dates?.dateRange?.startDate) === "NA"
        ? ""
        : formattedDateWithTime(dates?.dateRange?.startDate);
    const endDate =
      formattedDateWithTime(dates?.dateRange?.endDate) === "undefined" ||
      formattedDateWithTime(dates?.dateRange?.endDate) === "null" ||
      formattedDateWithTime(dates?.dateRange?.endDate) === "NA"
        ? ""
        : formattedDateWithTime(dates?.dateRange?.endDate);

    callQuoteAll(startDate, endDate);
  };

  const clearCalendar = () => {
    const { startDate, endDate } = getCurrentMonth();
    callQuoteAll(startDate, endDate);
  };

  const callQuoteAll = (date1: string, date2: string) => {
    dispatch(
      quoteAll({
        enable: state.enable,
        creationDateStart: date1,
        creationDateEnd: date2,
        page: state.page,
        limit: state.limit,
      }),
    );
  };

  return (
    <>
      <AlertLoadingHeader
        loading={loadingReports || loadingAllQuote}
        seeToast={toast}
        showToast={showToast}
        setSeeToast={setToast}
        titleLoading={t("salesReport.loading")}
      />
      <CustomReportPageView
        Tl={t}
        reportCard={state.reportCard}
        openReport={openReport}
        newDownData={newDownData}
        onClickMonthReport={onClickMonthReport}
        dataSeries={dataSeries}
        dataCategories={dataCategories}
        filterCalendar={filterCalendar}
        clearCalendar={clearCalendar}
      />
    </>
  );
};
